import { GetterTree } from 'vuex';
import { RootState } from '../../types';


export const getters: GetterTree<any, RootState> = {
    init(state): boolean {
        const { init } = state;
        return init;
    },
    isadmin(state): boolean {
        const { isadmin } = state;
        return isadmin;
    },
    isjdx(state): boolean {
        const { user } = state;
        return user.isjdx;
    },
    isSystemManager(state): boolean {
        const { user } = state;
        return user.roleid == "00001";
    },
    isUnitManager(state): boolean {
        const { user } = state;
        return user.roleid == "00003";
    },
    isPartyManager(state): boolean {
        const { user } = state;
        return user.roleid == "00002";
    },
    id(state): string {
        const { id } = state;
        return id;
    },
    roleid(state): string {
        const { roleid } = state;
        return roleid;
    },
    username(state): string {
        const { username } = state;
        return username;
    },
    companyname(state): string {
        const { companyname } = state;
        return companyname;
    },
    partyorgname(state): string {
        const { partyorgname } = state;
        return partyorgname;
    },
    rolename(state): string {
        const { rolename } = state;
        return rolename;
    },
    roleinfos(state): any {
        const { roleInfo } = state;
        return roleInfo;
    }
};